import cn from "classnames"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { FaqOutline, ChevronDown, ChevronUp, MinusLarge, PlusLarge } from "@/skylticons"

export interface HelpQuestion {
  question?: string | null
  answer?: string | null
}

interface HelpQuestionProps {
  question: HelpQuestion
}

interface HelpQuestionsProps {
  questions: HelpQuestion[]
  klass: string
}

const QuestionItem: React.FC<HelpQuestionProps> = ({ question }) => {
  const [show, setShow] = useState(false)

  return (
    <>
      <div className="question" onClick={() => setShow(show => !show)}>
        <FaqOutline />
        <p className="paragraph-sm mb-0">{question.question}</p>
        {show ? <ChevronUp /> : <ChevronDown />}
      </div>
      {show && (
        <div className="answer">
          <div dangerouslySetInnerHTML={{ __html: question.answer || "" }}></div>
        </div>
      )}
    </>
  )
}

const HelpQuestions: React.FC<HelpQuestionsProps> = ({ questions, klass }) => {
  const { t } = useTranslation()
  const [showMore, setShowMore] = useState(false)
  const firstBatch = questions.slice(0, 5)
  const secondBatch = questions.slice(5, questions.length)

  return (
    <div className={cn("card faq", klass)}>
      <p className="header bold">{t("pages.faq_header")}</p>
      {firstBatch.map(question => {
        return <QuestionItem question={question} key={question.question} />
      })}
      {showMore &&
        secondBatch.map(question => {
          return <QuestionItem question={question} key={question.question} />
        })}
      {secondBatch.length > 0 && (
        <a onClick={() => setShowMore(showMore => !showMore)} className="showmore text-base">
          {showMore ? (
            <>
              <MinusLarge />
              <span>{t("help_center.less_questions")}</span>
            </>
          ) : (
            <>
              <PlusLarge />
              <span>{t("help_center.more_questions", { count: secondBatch.length })}</span>
            </>
          )}
        </a>
      )}
    </div>
  )
}

export default HelpQuestions
